<header class="sh-dialog__header">
  <h3 class="sh-dialog__header__title">{{ 'maps.cluster-info-dialog.title' | translate }}</h3>
</header>
<div class="sh-dialog__content">
  @for (marker of clusterMarkers; track marker) {
    <section class="sh-template-stack__item">
      <ng-container *ngTemplateOutlet="itemDetail; context: { marker: marker}"> </ng-container>
    </section>
  }
</div>

<ng-template #itemDetail let-marker="marker">
  <figure class="sh-media-card--inline" style="box-shadow: none; min-width: 350px">
    <div class="sh-contained-media sh-media-card__media">
      <img [src]="marker.imgSrc" [alt]="marker.title" class="sh-contained-media__media--cover -sh-rounded" />
    </div>
    <figcaption class="sh-media-card__info">
      <a [shNavigationLink]="marker.navigationLink" class="sh-list-row-title sh-media-card__info__section sh-media-card__info__title">
        {{ marker.title }}
      </a>
      <address class="sh-media-card__info__section sh-media-card__info__content" style="padding-bottom: 8px">
        <p style="margin-top: 0px; margin-bottom: 8px">{{ marker.address }}</p>

        <div class="sh-action-bar">
          <div class="sh-action-bar__group">
            @if (marker.actionGroup) {
              <sh-action-group [actionGroup]="marker.actionGroup"></sh-action-group>
            }
          </div>
        </div>
      </address>
    </figcaption>
  </figure>
</ng-template>
